import React, { Fragment, PureComponent } from 'react';
import PropTypes from 'prop-types';
import ContentfulFields from 'components/ContentfulFields';
import Loader from 'components/Loader';
import { RangeSlider } from 'components/Ui';
import styles from './styles.scss';

class ContentfulPreview extends PureComponent {
  state = {
    zoomValue: 100,
  };

  componentDidMount() {
    const {
      match: { params },
      fetchContent,
    } = this.props;

    if (params.contentId) {
      fetchContent(params.contentId);
    }
  }

  onRangeChange = (event, value) => {
    this.setState({
      zoomValue: value,
    });
  };

  render() {
    const {
      preview: { loading, content },
    } = this.props;

    const { zoomValue } = this.state;

    return (
      <Loader loading={loading}>
        <h1 className={styles.title}>Contentful Content Preview</h1>
        {content ? (
          <Fragment>
            <div className={styles.zoom}>
              <span>Zoom: {zoomValue}%</span>
              <RangeSlider
                onChange={this.onRangeChange}
                min={1}
                max={150}
                step={1}
                value={zoomValue}
              />
            </div>
            <div
              style={{ zoom: `${zoomValue}%` }}
              className={styles.viewContainer}
            >
              <ContentfulFields
                type={content && content.sys.contentType.sys.id}
                document={content}
              />
            </div>
          </Fragment>
        ) : (
          <div className={styles.noContent}>
            No content fetched. To preview content visit
            <a
              target="_blank"
              href="https://app.contentful.com/spaces/x1vbd41hpla5/"
            >
              Contentful dashboard
            </a>
            <p>Content fetches by id of url:</p>
            <span>
              http://platform-web-dev.svsginfra.com/preview/
              <strong>entry.sys.id</strong>
            </span>
          </div>
        )}
      </Loader>
    );
  }
}

ContentfulPreview.propTypes = {
  fetchContent: PropTypes.func.isRequired,
  preview: PropTypes.object,
  match: PropTypes.object,
};

export default ContentfulPreview;
